import { LeftOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { BREAKPOINTS } from '@/ui';

export const BackBar = ({ url = null }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onBack = () => {
    url ? navigate(url) : navigate(-1);
  };

  return (
    <div style={{ width: '100%' }}>
      <Button icon={<LeftOutlined />} onClick={onBack}>
        {t('Back')}
      </Button>
    </div>
  );
};

const Button = styled(AntdButton)`
  height: 52px;
    padding: 10px 20px;

    @media (max-width: ${BREAKPOINTS.smd}px) {
        height: 36px;
        padding: 8px 16px;
    }
`;
